import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css';

import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);

reportWebVitals();
